import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Pagination,
} from '@mui/material';
import ListItemAgendaReport from './ListItemAgendaReport';
import { handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { useNavigate } from 'react-router-dom';
import { fetchReport } from '../../utils/lib';
import useAgendaActions from '../../hooks/useAgendaActions';
import { useTranslation } from 'react-i18next';

const AgendaCommonReport = ({ reportType, title }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const snackbar = useSnackbar();
  const navigate = useNavigate();
  
  // Usamos el hook centralizado para las acciones de agenda
  const {
    postponeDialog,
    completeDialog,
    handleReschedule,
    handlePostponeClose,
    handlePostponeConfirm,
    handleComplete,
    handleCompleteClose,
    handleCompleteConfirm,
    handleDateChange,
    AgendaDialogs
  } = useAgendaActions(fetchData, snackbar);

  useEffect(() => {
    fetchData(page);
  }, [reportType]);

  async function fetchData(pageNumber) {
    setIsLoading(true);
    try {
      const response = await fetchReport(reportType, pageNumber);
      //console.log(response);
      setData(response);
      setPage(pageNumber);
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  }
  
  const handlePageChange = (event, value) => {
    fetchData(value);
  };

  const handleAgendaEventClick = (agenda) => {
    navigate('/main/view-agenda-event', { state: { id: agenda.id } });
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data || !data.content || data.content.length === 0) {
    return (
      <Box textAlign="center" p={3}>
        <Typography variant="body1">{t('reports.noAgendaEvents')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          {title || t('reports.agendaEventsTitle')} ({data.total_results || data.content.length})
        </Typography>
      </Box>
      
      {data.content.map((agenda) => (
        <ListItemAgendaReport
          key={agenda.id}
          agenda={agenda}
          onReschedule={handleReschedule}
          onComplete={handleComplete}
          onClick={() => handleAgendaEventClick(agenda)}
        />
      ))}
      
      {data.total_pages && data.total_pages > 1 && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={data.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
      
      <AgendaDialogs />
    </Box>
  );
};

export default AgendaCommonReport; 